import React from "react";
import FormattedDay from "./formatted-day.js";
import WeatherTemperature from "./weather-temperature.js";

export default function WeatherInfo(props) {
  return (
    <div className="weather-info">
      <div className="weather-details">
        <h1 className="city">{props.data.city}</h1>
        <p>
          <span className="text-capitalize">
            <FormattedDay date={props.data.date} />
          </span>
          , <span className="text-capitalize">{props.data.description}</span>
          <br />
          Humidity:{" "}
          <strong>
            <span>{props.data.humidity}</span>%
          </strong>
          , Wind:{" "}
          <strong>
            <span>
              {props.unit === "imperial"
                ? props.data.wind
                : (props.data.wind / 2.237).toFixed(2)}
            </span>{" "}
            {props.unit === "imperial" ? "mph" : "km/h"}
          </strong>
        </p>
      </div>
      <div className="temperature-container">
        <div className="current-temp-img">
          <img src={props.data.imgUrl} alt={props.data.imgDesc} />
        </div>
        <WeatherTemperature
          unit={props.unit}
          data={props.data}
          setUnit={props.setUnit}
        />
      </div>
    </div>
  );
}
